<template>
<!-- 账号管理 -->
<section class="viewContainer">
  <div v-if="isBanner">
    <!--工具条-->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
      <div v-show="show3">
        <el-form :model="filters" class="findform">
          <el-form-item label="关键词语：" style="display:flex;width:20%">
            <el-input v-model="filters.name" placeholder="请输入员工账号/姓名/手机号" style="width:90%"/>
          </el-form-item>
          <el-form-item label="角色：" style="display:flex;width:20%" class="select">
            <el-select v-model="filters.roles" placeholder="请选择" style="width:90%">
              <el-option :label="item.rolename" :value="item.roleid" v-for="(item,index) in roleoptions" :key="index"/>
            </el-select>
          </el-form-item>
          <el-form-item label="所属店铺：" style="display:flex;width:20%" class="select">
            <el-select v-model="ListBbid" filterable placeholder="请选择" style="width:90%">
              <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in Listjigouoptions" :key="index"/>
            </el-select>
          </el-form-item>
          <el-form-item label="账号状态：" style="display:flex;width:20%">
            <el-select v-model="caozuo" placeholder="请选择" style="width:90%">
              <el-option :label="item.label" :value="item.Id" v-for="(item,index) in caozuoarr" :key="index"/>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="操作时间:" class="sub_chaxun">
              <el-date-picker type="date" class="normal_width" placeholder="选择日期" v-model="filters.date1" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker> <span class="line till">至</span>
              <el-date-picker class="normal_width" placeholder="选择时间" v-model="filters.date2" style="width: 100%;" value-format="yyyy-MM-dd" :picker-options="pickerOptions2"></el-date-picker>
          </el-form-item>-->
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- 列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title" style="width:58px">账号管理</p>
        <el-button type="danger" @click="showAddEdit('')" v-if="authority.indexOf('add')>-1" data-btnmark="add"
        style="float: right;margin: 5px 10px 0 0;">+ 新增</el-button>
      </section>
      <div class="table_container">
        <el-table :data="staffList" stripe border>
          <el-table-column prop="num" label="序号" align="center" width="60">
            <template scope="scope"> <span>{{scope.$index+1}}</span> </template>
          </el-table-column>
          <el-table-column prop="loginname" label="账号" align="center" width="120">
            <template scope="scope"><span :title="scope.row.loginname">{{scope.row.loginname}}</span></template>
          </el-table-column>
          <el-table-column prop="username" label="姓名" align="center" width="150">
            <template scope="scope"><span :title="scope.row.username">{{scope.row.username}}</span></template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" align="center" width="130">
            <template scope="scope"><span :title="scope.row.phone">{{scope.row.phone}}</span></template>
          </el-table-column>
          <el-table-column prop="rolename" label="角色" align="center" width="150">
            <template scope="scope"><span class="spanList" :title="scope.row.rolename">{{scope.row.rolename}}</span></template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="80">
            <template scope="scope">{{scope.row.isenabled==1?'禁用':'启用'}}</template>
          </el-table-column>
          <!-- <el-table-column prop="CoNum" label="发展共创端人数" align="center" width="160">
            <template scope="scope"><span :title="scope.row.CoNum">{{scope.row.CoNum}}</span></template>
          </el-table-column> -->
          <!-- <el-table-column prop="BbName" label="品牌" align="center"></el-table-column> -->
          <el-table-column prop="lastlogintime" label="最近登录时间" align="center" width="160">
            <template scope="scope"><span :title="scope.row.lastlogintime">{{scope.row.lastlogintime}}</span></template>
          </el-table-column>
          <el-table-column prop="creator" label="创建人" align="center" width="150">
            <template scope="scope"><span :title="scope.row.creator">{{scope.row.creator}}</span></template>
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间" align="center" width="160">
            <template scope="scope"><span :title="scope.row.createtime">{{scope.row.createtime}}</span></template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
            <template scope="scope"><span :title="scope.row.remark">{{scope.row.remark}}</span></template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="320" align="center">
            <div class="action_container" slot-scope="scope">
              <span class="handle" @click="showAddEdit(scope.row)" v-if="authority.indexOf('edit')>-1" data-btnmark="edit">
                <i class="el-icon-edit-outline"></i>编辑
              </span>
              <span class="handle" @click="setTingJs(scope.row)" v-if="authority.indexOf('setrole')>-1" data-btnmark="setrole">
                <i class="el-icon-setting" aria-hidden="true"></i>角色设置
              </span>
              <span class="handle" @click="mimachangzhi(scope.row)" v-if="authority.indexOf('resetpwd')>-1" data-btnmark="resetpwd">
                <i class="el-icon-unlock" aria-hidden="true"></i>重置密码
              </span>
              <span class="handle" @click="cardStatus(scope.row)" v-if="authority.indexOf('enabledordisable')>-1" data-btnmark="enabledordisable">
                <i :class="scope.row.isenabled == 0?'el-icon-circle-close':'el-icon-circle-check'"/>
                {{scope.row.isenabled == 0?"禁用":"启用"}}
              </span>
            </div>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right;"/>
      </div>
    </div>
  </div>

  <!--新增/编辑 界面-->
  <div class="main_container" v-else>
    <section class="model_section">
      <p class="model_top_title">账号管理{{editFormTtile}}</p>
    </section>
    <el-form :model="form" label-width="120px" ref="form" :rules="rules">
      <el-form-item label="账　　号：" prop="dlnumber">
        <el-input v-model="form.dlnumber" auto-complete="off" style="width:393px"/>
      </el-form-item>
      <el-form-item label="姓　　名：" prop="name">
        <el-input v-model="form.name" auto-complete="off" style="width:393px"/>
      </el-form-item>
      <el-form-item label="手 机 号：" prop="phonenumber">
        <el-input type="tel" v-model="form.phonenumber" auto-complete="off" maxlength="11" style="width:393px"/>
      </el-form-item>
      <el-form-item label="性　　别：">
        <el-select v-model="form.sex" placeholder="请选择" style="width:393px">
          <el-option :label="item.name" :value="item.val" v-for="(item,index) in sexArr" :key="index"/>
        </el-select>
      </el-form-item>
      <el-form-item label="邮　　箱：">
        <el-input type="email" v-model="form.email" auto-complete="off" style="width:393px"/>
      </el-form-item>
      <!-- <el-form-item label="旧密码：" prop="password" v-if="editFormTtile=='编辑'">
        <el-input  type="password" v-model="form.oldLoginPwd" auto-complete="off" style="width:360px"/>
      </el-form-item>-->
      <el-form-item label="所属城市：">
        <el-cascader v-model="chengshi" placeholder="请选择城市" :options="csOptions"
        filterable clearable @change="handleChangesscs" style="width:393px;"/>
      </el-form-item>
      <el-form-item label="所属店铺：" v-show="ptgly != 1||csgly != 1||qygly != 1">
        <el-select ref="select" v-model="form.BbId" filterable placeholder="请选择" style="width:393px">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in mechanismList" :key="index"/>
        </el-select>
      </el-form-item>
      <el-form-item label="备　　注：" prop="remark">
        <el-input type="textarea" v-model="form.remark" class="textarea" rows="3" style="width:393px;"/>
      </el-form-item>
    </el-form>
    <div  style="text-align: center;margin-bottom: 20px;">
      <el-button @click="cancelshow()">取 消</el-button>
      <el-button type="danger" @click="editBan()">保 存</el-button>
    </div>
  </div>

  <!-- 角色设置弹窗 -->
  <el-dialog title="角色设置" :visible.sync="dialogVisible" width="680px" height="422px">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true">
          <!-- 顶部搜索框 -->
          <el-form-item>
            <el-input v-model="searchKey" placeholder="请输入关键词" style="width:230px"/>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="getSortList">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="confirmSetRole">确定</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-row class="shut">
      <el-col :span="12"><p>角色列表</p></el-col>
      <el-col :span="12"><p>已选角色</p></el-col>
    </el-row>
    
    <el-row class="shuttle">
      <el-col :span="12"></el-col>
      <div style="width:50%;float:left" class="TLeft">
        <p v-for="(val,index) in TData" @click="checkImg(val,index)" :key="index" v-show="val.rolename.indexOf(tempkey)>-1">
          <img :src="src1" alt v-if="val.ischecked==0" class="left_img" style />
          <img :src="src2" alt v-else class="left_img" />
          <span>{{val.rolename}}</span>
        </p>
      </div>
      <el-col :span="12" class="border_r">
        <div class="TRight" v-for="(item,index) in TData" :key="index" v-show="item.ischecked==1">
          <p>{{item.rolename}}</p>
          <img src="../../assets/img/aicon36.png" alt @click="canCheck(item,index)" class="chahao"/>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
  <!-- 重置密码 -->
  <el-dialog title="提示" :visible.sync="resetpassword" width="30%">
    <span>确定重置当前员工：{{byphonechange}} 的用户密码么？</span>
    <span slot="footer" class="dialog-footer">
      <el-button class="span" @click="resetpassword = false">
        <span style="margin-left:-5px;margin-top:-5px;">取 消</span>
      </el-button>
      <el-button class="span" type="primary" @click="changemima">
        <span style="margin-left:-5px;margin-top:-5px;">确 定</span>
      </el-button>
    </span>
  </el-dialog>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import util from "../../common/util";
import NProgress from "nprogress";
import {getStaffBack,buttongetlist,provincegetcountys} from "../../api/newOss";
import { editUser, addUser, juese, yuangongjigou } from "../../api/api";
import { useradd,usergetlist, userchangestatus, useredit, usergetinfo, userpwdreset,rolegetlist,userroleset, rolegetrolelist } from "../../api/comment";
export default {
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      issure: true,
      Listjigouoptions: "",
      ListBbid: 0,
      caozuo: -1,
      caozuoarr: [
        {
          Id: -1,
          label: "全部"
        },
        {
          Id: 1,
          label: "禁用"
        },
        {
          Id: 0,
          label: "启用"
        }
      ],
      resetpassword: false, // 重置密码
      // 角色设置弹窗
      dialogVisible: false,
      searchKey: "",
      tempkey: "",
      alreadyChoose: [],
      filters: {
        name: "",
        name1: "",
        date1: "",
        date2: "",
        roles: ""
      },
      staffList: [],
      total: 1,
      chengshi: [],
      csOptions: [],
      editId: "", // 用户ID
      byphonechange: "",
      editFormTtile: "新增",
      form: {
        dlnumber: "",
        name: "",
        phonenumber: "",
        sex: 1,
        email: "",
        provinceId: 0, // 省
        cityId: 0, // 市
        zoneId: 0, // 区县
        BbId: '',
        remark: "",
        password: "",
      },
      sexArr: [
        {
          name: "女",
          val: 0
        },{
          name: "男",
          val: 1
        }
      ],
      // 验证规则
      rules: {
        dlnumber: [
          {
            required: true, //是否必填
            trigger: "blur", //何事件触发
            message: " "
          }
        ],
        name: [
          {
            required: true, //是否必填
            trigger: "blur", //何事件触发
            message: " "
          }
        ],
        phonenumber: [
          {
            required: true, //是否必填
            trigger: "blur", //何事件触发
            message: " "
          }
        ],
        sex: [
          {
            required: true, //是否必填
            trigger: "blur", //何事件触发
            message: " "
          }
        ],
        email: [
          {
            required: true, //是否必填
            trigger: "blur", //何事件触发
            message: " "
          }
        ],
        password: [
          {
            required: true, //是否必填
            trigger: "blur", //何事件触发
            message: " "
          }
        ],
      },
      TData: [],
      isBanner: true, // banner是否显示
      src1: require("../../assets/img/aicon13.png"),
      src2: require("../../assets/img/aicon10.png"),
      pageIndex: 1,
      roleoptions: "",
      mechanismList: [], // 所属机构
      pageSize: 10,
      pickerOptions2: {
        disabledDate: time => {
          let beginDateVal = this.filters.date1;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      },
      authority: '', // 按钮权限
      ptgly: '', // 平台(全国)管理员
      csgly: '', // 城市管理员
      qygly: '', // 企业管理员
    };
  },
  methods: {
    // 获取员工列表
    init() {
      var loginParams = {
        // userId: localStorage.Id,
        keyword: this.filters.name,
        roleid: this.filters.roles, // 角色
        shopid: this.ListBbid, // 所属店铺
        isenabled: this.caozuo, // 是否启用-1=全部 0=启用 1=禁用
        enterpriseid: 0, // 企业ID 默认0
        // startTime: this.filters.date1,
        // endTime: this.filters.date2,
        pageindex: this.pageIndex,
        pagesize: this.pageSize
      };
      usergetlist(loginParams).then(data => {
        if (data.resultCode == 1) {
          this.staffList = data.resultObj.list;
          this.total = data.resultObj.totalcount;
        }else{
          this.staffList = [];
          this.total = 0;
        }
      }).catch(err => {
        this.staffList = [];
        this.total = 0;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 列表页所属机构
    getListyuangong() {
      var loginParams = {
        key: "",
        provinceId: 0,
        cityId: 0,
        cooperationTypeId: 0,
        statusId: 0
      };
      yuangongjigou(loginParams).then(data => {
        this.Listjigouoptions = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        this.Listjigouoptions.unshift(obj);
        this.ListBbid = this.Listjigouoptions[0].Id;
      })
    },
    // 查询
    getSortList() {
      this.tempkey = this.searchKey;
    },
    
    //获取角色列表
    getrole() {
      rolegetrolelist('').then(data => {
        var obj = {
          roleid: "",
          rolename: "全部"
        };
        data.resultObj.unshift(obj);
        this.roleoptions = data.resultObj;
      });
    },

    // 角色设置
    setTingJs(row) {
      this.issure = true;
      this.dialogVisible = true;
      this.searchKey='';
      this.alreadyChoose = [];
      this.editId = row.userid;
      let params = {
        userid: row.userid, // 用户ID
        roleName: this.searchKey, // 角色名称 模糊匹配 需urlencode一次
      };
      rolegetlist(params).then(res => {
        this.TData = res.resultObj || [];
      })
    },
    // 选中角色
    checkImg(val, index) {
      if (this.TData[index].ischecked) {
        this.TData[index].ischecked = 0;
      } else {
        this.TData[index].ischecked = 1;
      }
    },
    // 取消选中角色
    canCheck(item, index) {
      this.TData[index].ischecked = 0;
    },
    // 角色设置-确认
    confirmSetRole() {
      this.issure = false;
      let tempRoles = [],
      that = this;
      this.TData.forEach(el => {
        if (el.ischecked == 1) {
          tempRoles.push(el.roleid);
        }
      });
      let params = {
        userid: this.editId, // 用户ID
        operatorid: localStorage.Id, // 操作人ID
        // roles: tempRoles.join(","), // 角色ID数组
        roles: tempRoles, // 角色ID数组
      };
      userroleset(params).then(data => {
        if (data.resultCode == 1) {
          that.dialogVisible = false;
          this.showAlert('设置成功', 'success');
          that.init();
        }else{
          this.showAlert(data.resultMsg);
        }
      });
    
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    // 重置
    fnReset() {
      this.filters = {
        name: "",
        name1: "",
        date1: "",
        date2: "",
        roles: ""
      },
      this.ListBbid = 0;
      this.caozuo = -1;
      // this.pageIndex = 1;
      // this.init();
    },
    // 新增 & 编辑+回显
    showAddEdit(row) {
      this.getprovince(); // 获取省市区
      this.isBanner = false;
      if(row){
        this.editId = row.userid;
        this.editFormTtile = "编辑";
        
        usergetinfo('',row.userid).then(res => {
          let datainfo = res.resultObj.info; // 用户基本信息
          this.form.dlnumber=datainfo.loginname; // 登录账号
          this.form.name=datainfo.username; // 用户姓名
          this.form.phonenumber=datainfo.phone; // 手机号
          this.form.sex=datainfo.sex==-1?'':datainfo.sex; // 性别0=女 1=男
          this.form.email=datainfo.email; // 电子邮箱
          this.form.provinceId=datainfo.pid; // 省份ID
          this.form.cityId=datainfo.cid; // 城市ID
          this.form.zoneId=datainfo.scid; // 区县ID
          this.chengshi = [ this.form.provinceId, this.form.cityId, this.form.zoneId ]; // 所属城市
          this.form.BbId=datainfo.shopid?datainfo.shopid:''; // 所属店铺ID
          this.form.remark=datainfo.remark; // 备注
          this.ptgly = res.resultObj.roles.isplatformadmin; // 是否是全国管理员0=否 1=是
          this.csgly = res.resultObj.roles.iscityadmin; // 是否是城市管理员0=否 1=是
          this.qygly = res.resultObj.roles.isenterpriseadmin; // 是否是企业管理员0=否 1=是
        })
      }else{
        this.editId = '';
        this.editFormTtile = "新增";
        this.form.dlnumber = "";
        this.form.name = "";
        this.form.phonenumber = "";
        this.form.sex = 1;
        this.form.email = "";
        this.form.provinceId = 0;
        this.form.cityId = 0;
        this.form.zoneId = 0;
        this.chengshi=[];
        // this.form.BbId = Number(localStorage.BbId);
        this.form.BbId = '';
        this.form.remark = "";
      }
    },
    // 取消
    cancelshow() {
      this.isBanner = true;
    },
    // 保存
    editBan() {
      if (this.form.dlnumber == "") {
        this.showAlert('请输入账号');
        return false;
      }
      if (this.form.name == "") {
        this.showAlert('请输入姓名');
        return false;
      }
      if (this.form.phonenumber == "") {
        this.showAlert('请输入手机号');
        return false;
      }
      if (this.form.phonenumber != "") {
        var reg = /^[1][3,4,5,7,8,9,6][0-9]{9}$/;
        if (!reg.test(this.form.phonenumber)) {
          this.showAlert('请输入正确的手机号');
          return false;
        }
      }
      // if (this.form.email != "") {
      //   var reg1 = new RegExp(
      //     "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      //   );
      //   if (!reg1.test(this.form.email)) {
      //     this.showAlert('请输入正确的邮箱格式');
      //   }
      // }
      if ( this.form.email != "" && this.form.email + "" != "null" && this.form.email + "" != "无" ) {
        var reg1 = /^\w+@[a-z0-9]+\.[a-z]{2,4}$/;
        if (!reg1.test(this.form.email)) {
          this.showAlert('请输入正确的邮箱格式');
          return false;
        }
      }
      if(this.editId){ var yhid = this.editId; }
      let loginParams = {
        userid: yhid, // 用户ID
        username: this.form.name, // 姓名
        phone: this.form.phonenumber, // 手机号
        loginname: this.form.dlnumber, // 登录账号
        sex: this.form.sex?this.form.sex:1, // 性别 -1=未选择 0=女 1=男
        email: this.form.email, // 电子邮箱
        remark: this.form.remark, // 备注
        operatorid: localStorage.Id, // 当前操作人ID
        enterpriseid: 0, // 所属企业ID
        shopid: this.form.BbId?this.form.BbId:0, // 所属店铺ID
        pid: this.form.provinceId, // 所属省份ID
        cid: this.form.cityId, // 所属城市ID
        scid: this.form.zoneId, // 所属区县ID
        nickname: '', // 昵称 （没有可传空）
        icon: '', // 用户头像（完整路径）

        // BbId: this.form.BbId == "甄惠装平台" ? 1 : this.form.BbId,
        // LoginPwd: this.form.password,
      };
      let thisApi = this.editId==''?useradd:useredit;
      thisApi(loginParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.isBanner = true;
          this.init();
        }
      })
    },
    // 重置密码
    mimachangzhi(row) {
      this.editId = row.userid;
      this.byphonechange = row.phone;
      this.$swal({
        type: "warning",
        text: "确定重置当前员工：" + this.byphonechange + " 的用户密码么？",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          this.changemima();
        }
      });
    },
    // 确定重置密码
    changemima() {
      this.resetpassword = false;
      var obj = {
        userid: this.editId, // 用户ID
        operatorid: localStorage.Id, // 操作人ID
      };
      userpwdreset(obj).then(data => {
        console.log(data,1111)
        if (data.resultCode == 1) {
          this.resetpassword = false;
          this.showAlert('重置密码成功', 'success');
        }
      });
    },
    // 启用&禁用
    cardStatus(row){
      this.$swal({
        type: "warning",
        text: row.isenabled == 0 ? "是否执行禁用操作" : "是否执行启用操作",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          // 确定执行操作
          let obj = {
            userid: row.userid, // 用户ID
            status: row.isenabled == 0 ? 1 : 0 // 0=启用 1=禁用
          }
          userchangestatus(obj).then(data=>{
            if(data.resultCode == 1){
              this.init();
              this.showAlert('操作成功', 'success');
            }
          })
        }
      });
    },

    // 编辑 or 新增
    editSubmit() {
      var _this = this;
      _this.$refs.editForm.validate(valid => {
        if (valid) {
          _this.$confirm("确认提交吗？", "提示", {}).then(() => {
            _this.editLoading = true;
            NProgress.start();
            _this.btnEditText = "提交中";

            if (_this.editForm.id == 0) {
              //新增
              let para = {
                name: _this.editForm.name,
                sex: _this.editForm.sex,
                age: _this.editForm.age,
                birth:
                  _this.editForm.birth == ""
                    ? ""
                    : util.formatDate.format(
                        new Date(_this.editForm.birth),
                        "yyyy-MM-dd"
                      ),
                addr: _this.editForm.addr
              };
              addUser(para).then(res => {
                _this.editLoading = false;
                NProgress.done();
                _this.btnEditText = "提 交";
                this.showAlert('提交成功', 'success');
              });
            } else {
              //编辑
              let para = {
                id: _this.editForm.id,
                name: _this.editForm.name,
                sex: _this.editForm.sex,
                age: _this.editForm.age,
                birth:
                  _this.editForm.birth == ""
                    ? ""
                    : util.formatDate.format(
                        new Date(_this.editForm.birth),
                        "yyyy-MM-dd"
                      ),
                addr: _this.editForm.addr
              };
              editUser(para).then(res => {
                _this.editLoading = false;
                NProgress.done();
                _this.btnEditText = "提 交";
                this.showAlert('提交成功', 'success');
              });
            }
          });
        }
      });
    },

    // 获取所属店铺
    getAffiliatedInstitutions() {
      // var loginParams = {
      //   key: "",
      //   provinceId: 0,
      //   cityId: 0,
      //   zoneId: 0,
      //   cooperationTypeId: 0,
      //   statusId: 1
      // };
      let loginParams = {
        staffId: localStorage.Id, // 操作人id
      };
      getStaffBack(loginParams).then(data => {
        let obj = {
          id: 0,
          name: "请选择"
        };
        data.resultObj.unshift(obj);
        this.mechanismList = data.resultObj;
        // this.form.BbId = this.mechanismList[0].Id;
      })
    },
    // 请选择省市
    handleChangesscs(val) {
      this.form.provinceId = val[0]; // 省
      this.form.cityId = val[1]; // 市
      this.form.zoneId = val[2]; // 区
    },
    // 查找省市区
    getprovince() {
      var loginParams = {
        isopen: 1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        // 需要给区县加全市 用这段
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          item.citys.forEach(city => {
            // 添加表示“全市”的选项
            const allCityOption = {
              value: 0, label: "全市"
            };
            const cityObj = {
              value: city.cid, label: city.cname,
              children: [allCityOption].concat(city.countys.map(zone => ({
                value: zone.scid, label: zone.scname
              })))
            };
            province.children.push(cityObj);
          });
          provinceOptions.push(province);
        });
        this.csOptions = provinceOptions;
        this.csOptions.unshift({value: 0, label: "全国"});
        
        // 这块代码也是没问题的
        // let that = this;
        // let provinceAndCityAndarea = [];
        // data.resultObj.forEach(item => {
        //   // 省
        //   let provinceData = {value:item.pid,label:item.pname,children:[]};
        //   provinceAndCityAndarea.push(provinceData);
        //   // 市
        //   item.citys.forEach(city => {
        //     // 添加表示“全市”的选项
        //     let allCityOption = {value:0,label:"全市"};
        //     let cityData = {value:city.cid,label:city.cname,children:[allCityOption]}; // 将“全市”选项放在最前面
        //     // 区
        //     city.countys.forEach(zone => {
        //       cityData.children.push({value:zone.scid,label:zone.scname});
        //     })
        //     provinceData.children.push(cityData);
        //   });
        // });
        // that.csOptions = provinceAndCityAndarea;
        // that.csOptions.unshift({
        //   value: 0,
        //   label: "全国",
        // });

      }).catch(error => {
        console.error('获取省市区数据失败:', error);
      });
    },
    // 按钮权限
    handlebtn(){
      let obj = {mark: 'staff',};
      buttongetlist(obj).then(data => {
        this.authority = data.resultObj;
      })
    },
  },
  mounted() {
    this.handlebtn(); // 按钮权限
    this.init();
    this.getListyuangong(); //获取列表页员工机构
    this.getAffiliatedInstitutions(); // 获取所属店铺
    this.getrole(); // 获取角色列表
  },
};
</script>
<style scoped>
.span {
  background: #fff;
  display: inline-block;
  width: 60px;
  height: 38px;

  border: 1px solid #F56C6C;

  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}
.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}
.el-checkbox__label {
  padding: 15px;
  display: inline-block;
  /* padding-left: 10px; */
  line-height: 19px;
  font-size: 14px;
}

/* 穿梭框 */
.shuttle {
  border: 1px solid #eee;
}

.TLeft {
  width: 49%;
  float: left;
  height: 220px;
  overflow-y: auto;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 40px;
  box-sizing: border-box;
}

.TLeft p {
  /* margin-left: 20px; */
  color: #000;
  font-size: 12px;
  width: 90%;
}

/* 选择框 */
.TLeft .left_img {
  width: 16px;
  height: 16px;
  z-index: 999;
  margin-bottom: 6px;
  cursor: pointer;
}

.border_r {
  border-left: 1px solid #eee;
  height: 220px;
  overflow-y: auto;
  padding-left: 20px;
  padding-bottom: 20px;
}

.TRight {
  position: relative;
  width: 68%;
  /* height: 50px; */
  /* display: inline-block; */
}

.TRight p {
  background: #f2f2f2;
  text-align: center;
  /* margin-top: 18px; */
  margin-left: 13px;
  padding: 5px 15px;
}

.TRight img {
  position: absolute;
  top: -8px;
  right: -8px;
  cursor: pointer;
}

/* 角色列表 */
.shut p {
  border-right: 1px solid #eee;
  height: 50px;
  background: #bbb;
  line-height: 50px;
  padding-left: 20px;
  font-size: 12px;
  color: #000;
  opacity: 0.49;
  margin: 15px 0 0 0;
}
</style>




// WEBPACK FOOTER //
// staff.vue?7885edb1